(() => {
  if (customElements.get('royal-scratch-popup')) return;
  class RoyalScratchPopup extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.canvas = this.querySelector('[data-canvas]');
      this.context = this.canvas.getContext('2d', { willReadFrequently: true });
      this.reveal = this.querySelector('[data-reveal]');
      this.key = 'royal-scratch-gift-v1';
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.close(), options));
      this.dialog.addEventListener('cancel', () => this.remember(), options);
      this.reveal.addEventListener('click', () => this.unlock(), options);
      this.canvas.addEventListener('pointerdown', event => {
        if (this.unlocked) return;
        this.drawing = true;
        this.canvas.setPointerCapture(event.pointerId);
        this.last = null;
        this.erase(event);
      }, options);
      this.canvas.addEventListener('pointermove', event => {
        if (this.drawing) this.erase(event);
      }, options);
      const end = () => {
        this.drawing = false;
        this.last = null;
        if (!this.unlocked && this.context) {
          const pixels = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height).data;
          let clear = 0;
          let total = 0;
          for (let i = 3; i < pixels.length; i += 64) { total++; if (pixels[i] < 128) clear++; }
          if (clear / total > .32) this.unlock();
        }
      };
      this.canvas.addEventListener('pointerup', end, options);
      this.canvas.addEventListener('pointercancel', end, options);
      this.querySelector('[data-return]').value = location.pathname + location.search;
      this.querySelector('form').addEventListener('submit', () => {
        const button = this.querySelector('[data-submit]');
        if (!button) return;
        button.disabled = true;
        button.textContent = this.querySelector('[data-copy-loading]').textContent;
        this.remember();
        this.submitTimer = setTimeout(() => {
          if (this.isConnected) { button.disabled = false; button.textContent = this.submitLabel; }
        }, 15000);
      }, options);
      this.submitLabel = this.querySelector('[data-submit]')?.textContent;
      const returned = this.querySelector('[data-success], [data-form-error]');
      let dismissed = false;
      try { dismissed = Date.now() - Number(localStorage.getItem(this.key) || 0) < Number(this.dataset.days) * 86400000; } catch { dismissed = true; }
      if (returned) { this.open(); this.unlock(); }
      else if (this.dataset.preview === 'true' || !dismissed) {
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
      }
    }
    open() {
      if (!this.isConnected || this.dialog.open || document.querySelector('dialog[open]') || document.visibilityState !== 'visible') return;
      this.dialog.showModal();
      this.remember();
      if (!this.context) { this.unlock(); return; }
      this.canvas.width = Math.round(this.canvas.clientWidth);
      this.canvas.height = Math.round(this.canvas.clientHeight);
      const { width, height } = this.canvas;
      const gradient = this.context.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#dcc397');
      gradient.addColorStop(.5, '#f0dfbd');
      gradient.addColorStop(1, '#baa078');
      this.context.fillStyle = gradient;
      this.context.fillRect(0, 0, width, height);
      this.context.fillStyle = '#60492e';
      this.context.textAlign = 'center';
      this.context.font = '22px Georgia, serif';
      this.context.fillText('ROYAL CROWN', width / 2, height / 2 - 12);
      this.context.font = '12px Arial, sans-serif';
      this.context.fillText('DEIN GESCHENK ENTDECKEN', width / 2, height / 2 + 15);
    }
    erase(event) {
      if (!this.context) return;
      const rect = this.canvas.getBoundingClientRect();
      const point = { x: (event.clientX - rect.left) * this.canvas.width / rect.width, y: (event.clientY - rect.top) * this.canvas.height / rect.height };
      this.context.globalCompositeOperation = 'destination-out';
      this.context.lineWidth = 40;
      this.context.lineCap = 'round';
      this.context.beginPath();
      this.context.moveTo(this.last?.x ?? point.x, this.last?.y ?? point.y);
      this.context.lineTo(point.x + .1, point.y + .1);
      this.context.stroke();
      this.last = point;
    }
    unlock() {
      if (this.unlocked) return;
      this.unlocked = true;
      this.drawing = false;
      this.canvas.hidden = true;
      this.reveal.hidden = true;
      this.querySelector('[data-signup]').hidden = false;
      this.querySelector('[data-status]').textContent = this.querySelector('[data-copy-reward]').textContent;
    }
    remember() { try { localStorage.setItem(this.key, String(Date.now())); } catch {} }
    close() { this.remember(); this.dialog.close(); }
    disconnectedCallback() { clearTimeout(this.timer); clearTimeout(this.submitTimer); this.controller?.abort(); if (this.dialog?.open) this.dialog.close(); this.ready = false; }
  }
  customElements.define('royal-scratch-popup', RoyalScratchPopup);
})();